import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-right\">\n<path d=\"M115 475L385.01 250L115 25\" stroke=\"currentColor\" stroke-width=\"35.5916\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol